var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroFourth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8181_2655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4675 34.122L25.3519 27.0148L26.3461 26.0198L33.4617 33.127L32.4675 34.122ZM19.1116 18.6005L10.8928 10.7437L9.92039 11.7598L18.1392 19.6165L19.1116 18.6005ZM18.1364 27.1962L17.1422 26.202L11.7731 31.571L12.7673 32.5652L18.1364 27.1962ZM33.9905 11.3428L32.9962 10.3486L25.3519 17.993L26.3461 18.9872L33.9905 11.3428ZM22.5422 28.2375H21.1359V38.6367H22.5422V28.2375ZM22.5422 7.03125H21.1359V16.7695H22.5422V7.03125ZM15.8105 21.7969H9.70312V23.2031H15.8105V21.7969ZM39.4172 21.7969H27.5695V23.2031H39.4172V21.7969Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0269 4.92062C19.1415 1.20319 24.538 1.2039 24.6519 4.92062C24.5373 8.63804 19.1408 8.63733 19.0269 4.92062ZM21.8492 37.9302C16.2777 38.0434 16.2784 42.7762 21.8492 42.8894C27.4208 42.7762 27.4201 38.0434 21.8492 37.9302ZM12.7761 8.56421L9.96359 5.75171L6.12172 6.78108L5.09234 10.623L7.90484 13.4355L11.7467 12.4061L12.7761 8.56421ZM34.1771 5.23843L30.2178 9.19772L34.9688 13.9487L38.9281 9.98944L34.1771 5.23843ZM3.47656 19.289V25.6677C3.47656 26.2091 4.06227 26.5473 4.53125 26.2766L10.0557 23.0873C10.5247 22.8166 10.5247 22.1401 10.0557 21.8694L4.53125 18.6801C4.06227 18.4094 3.47656 18.7476 3.47656 19.289ZM41.5262 19.6862C37.8073 19.8016 37.8102 25.1973 41.5262 25.3112ZM32.5016 33.1616C30.6369 35.0263 30.6369 38.0491 32.5016 39.913L39.253 33.1616C37.3883 31.2969 34.3655 31.2969 32.5016 33.1616ZM10.2484 37.1708L12.6045 34.8147C13.4525 33.9667 13.4525 32.5801 12.6045 31.7322C11.7566 30.8842 10.37 30.8842 9.52203 31.7322L7.16586 34.0884C5.19078 36.1752 8.16078 39.1466 10.2484 37.1708ZM26.3879 17.9495C24.1006 15.4759 19.5725 15.4766 17.2895 17.9495H17.2824C14.8039 20.2361 14.8081 24.7719 17.2824 27.055C19.5655 29.5293 24.102 29.5328 26.3879 27.055V27.048C28.8615 24.7649 28.8615 20.2368 26.3879 17.9495Z",
    fill: "url(#paint0_radial_8181_2655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8411 26.0169C20.8989 26.0169 20.0144 25.6513 19.3506 24.9883C18.0288 23.7184 17.9817 21.4417 19.2494 20.1191L19.3528 20.0179C20.6767 18.6503 23.0048 18.6503 24.3288 20.0179C25.6879 21.3334 25.6872 23.6692 24.3217 24.9862L24.2071 25.1008C23.5582 25.6935 22.7242 26.0176 21.8404 26.0176L21.8411 26.0169Z",
    fill: "#0076AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8181_2655",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23 21.5) rotate(90) scale(23.5 21.9392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45BCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#88CDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085C2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8181_2655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroFourth);
export default __webpack_public_path__ + "static/media/hero-fourth.46b72f829119c74af38fe0e2174cf0e4.svg";
export { ForwardRef as ReactComponent };